import React, { } from "react";
import Container from "../../General/Container/Container";
import BarChart from "../../Charts/BarChart";
import { Empty, Skeleton, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

function MinifiedInsightsAge({ loading, data, colors }) {
    return <Container className="fullh dcol align-center justify-center gap-1" style={{ width: "63%" }}>
        {
            loading
                ? <Skeleton.Avatar
                    active
                    shape="square"
                    style={{
                        height: "60mm", width: "130mm"
                    }}
                />
                : <>
                    <Container className="drow justify-start fullw align-center">
                        <span style={{
                            paddingLeft: "6mm",
                            color: "#475569",
                            fontSize: "16px",
                            fontWeight: "600",
                            marginRight: "2mm"
                        }}>Age</span>
                        <Tooltip placement="right" title="Age distribution data are provided by Google™.">
                            <InfoCircleOutlined style={{ cursor: "pointer", color: "var(--bluegray-400)" }} />
                        </Tooltip>
                    </Container>
                    <BarChart
                        chartProps={{
                            data: data.reverse(),
                            xField: "score",
                            yField: "title",
                            seriesField: "title",
                            legend: false,
                            colorField: 'title',
                            color: colors,
                            xAxis: {
                                label: {
                                    formatter: (e) => {
                                        return parseFloat(e) * 100;
                                    }
                                },
                                grid: {
                                    line: {
                                        style: {
                                            stroke: 'black',
                                            lineWidth: 1,
                                            lineDash: [2, 3],
                                            strokeOpacity: 0.7,
                                            cursor: 'pointer'
                                        }
                                    }
                                }
                            }
                        }}
                        style={{
                            width: "90%",
                            height: "90%",
                            marginTop: 0
                        }}
                    />
                </>
        }
    </Container>
}
export default MinifiedInsightsAge;
